
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";
import * as React from "react";

interface StandardDialogProps {
  trigger: React.ReactNode;
  title: string;
  children: React.ReactNode;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function StandardDialog({ 
  trigger, 
  title, 
  children, 
  className,
  open,
  onOpenChange
}: StandardDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className={cn(
        "px-8 py-6 rounded-lg border-none bg-white shadow-lg",
        "sm:max-w-[425px] gap-0",
        className
      )}>
        <DialogHeader className="pb-4">
          <DialogTitle className="text-lg font-semibold leading-none text-left">
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {children}
        </div>
        <DialogClose className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
